export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_USER = 'SET_USER';
export const SET_WEB5 = 'SET_WEB5';
